import LinkToolbarView from "./LinkToolbarView.vue";
import {Link as LinkExtension} from "@tiptap/extension-link";
import LinkBubbleView from "./LinkBubbleView.vue";
import {isActive} from "@tiptap/vue-3";

export default class Link {

    constructor() {
        this.toolbarView = LinkToolbarView;
        this.bubbleView = LinkBubbleView;
    }

    showBubble(props) {
        return isActive(props.state, "link");
    }

    static create() {
        return new Link();
    }

    getExtensions() {
        return [LinkExtension.configure({
            openOnClick: false,
            HTMLAttributes: {
                class: "btn btn-link btn-primary d-inline",
                style: "vertical-align: unset"
            }
        })];
    }
}